import { all } from 'redux-saga/effects';
import handlersWatcher from './HandlersSaga';

function* handlersSaga() {
  yield all([
    handlersWatcher(),
  ]);
}

export default handlersSaga;
